import styled, { css } from 'styled-components';

import { PopupBase } from '@r1-frontend/ui-kit/molecules/Popup/components/PopupBase';
import { PopupContent } from '@r1-frontend/ui-kit/molecules/Popup/components/PopupContent';
import { PopupHeader } from '@r1-frontend/ui-kit/molecules/Popup/components/PopupHeader';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';
import { IImageSource, progressiveBackground } from '@r1-frontend/shared/helpers/progressiveBackground';

import { PopupBaseProps } from './components/PopupBase';
import { getSizes } from './helpers';

export type TPopupWithImageProps = PopupBaseProps & {
    $image: IImageSource,
}

const PopupWithImage = styled(
    ({ children, ...props }: TPopupWithImageProps) => (
        <PopupBase {...props}>
            <PopupHeader onClose={props.onClose}/>
            <PopupContent>{children}</PopupContent>
        </PopupBase>
    ),
)`
    ${({ theme, $image }: ThemedProperties<TPopupWithImageProps>) => css`
        article[role="dialog"] {
            padding: 0;
            gap: 0;

            ${getSizes()}
        }

        ${PopupHeader} {
            flex-shrink: 0;

            height: 140px;
            padding: ${theme.indents.m}px ${theme.indents.m}px ${theme.indents.s}px;

            ${progressiveBackground($image)};

            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
        }

        ${PopupContent} {
            margin-right: ${theme.indents.xxs}px;
            padding: ${theme.indents.m}px;
        }

        @media (min-width: ${theme.breakpoints.tablet}) {
            ${PopupHeader} {
                height: 320px;
            }

            ${PopupContent} {
                padding: ${theme.indents.l}px;
            }
        }
    `}
`;

PopupWithImage.displayName = 'Popup_WithImage';

export { PopupWithImage };
